module.exports = __webpack_public_path__ + "img/map.7368fd99.png";